import '@src/assets/style/main.scss'
import {isEmpty, setTitle} from '@src/util'
import {DatePicker, Picker, Toast} from 'antd-mobile-v2'
import moment from 'moment'
import React from 'react'
import EndlessList from '@component/endlessList'
import {formatString} from "@src/constant";
import CommonService from "@service/commonService";
import {ArchiveListItem} from "@src/type";
import INavBar from "@component/INavBar";
import {goto} from "@src/route";

const CheckStatus = [{value: 1, label: '未提交'},
	{value: 2, label: '待审核'},
	{value: 3, label: '已通过'},
	{value: 4, label: '已驳回'}]
const FinalStatus = [{value: 1, label: '未归档'}, {value: 2, label: '已归档'}]

type ListTableStateType = {
	pages: number
	list: any[]
	total: number
	params: {
		phone: string
		checkStatus?: any
		finalStatus?: any
	}
	loading?: boolean
}

export default class ListTable extends React.Component<any,
	ListTableStateType> {
	ref?: any
	containerRef?: any
	datePickerRef?: any

	constructor(props: any) {
		super(props)
		setTitle("归档")
		this.state = {
			pages: 0,
			list: [],
			total: 0,
			params: {
				phone: '',
			},
		}
	}

	onRefresh(state?: ListTableStateType) {
		const {list, total, pages, params} = state || this.state
		if (total && list.length >= total) {
			return
		}
		const newPage = pages + 1
		const param: any = {
			...params,
			pages: newPage,
			rows: 10
		}
		if (isEmpty(param.phone)) {
			delete param.phone
		}

		this.setState({loading: true})
		CommonService.getArchiveList(param).then(data => {
			this.setState({loading: false})
			if (data) {
				let _list: any[] = data.rows || []
				const _total = data.total || 0
				_list = list.concat(_list)
				this.setState({total: _total, list: _list, pages: newPage})
			} else {
				Toast.fail('数据加载失败...')
			}
		}).catch(e => {
			this.setState({loading: false})
			Toast.fail('数据加载失败...')

		})
	}

	componentDidMount() {
		this.onRefresh()
	}

	filterItemChange(type: 'cstatus' | 'fstatus', value: any) {
		const {params} = this.state
		if (type === 'cstatus') {
			params.checkStatus = value
		} else if (type === 'fstatus') {
			params.finalStatus = value
		}

		const state = {params, pages: 0, list: [], total: 0}
		this.setState(state)
		this.onRefresh(state)
		this.containerRef?.querySelector('div').scrollTo({top: 0})
	}

	asignPersonCallback() {
		const {params} = this.state
		const state = {params, pages: 0, list: [], total: 0}
		this.setState(state)
		this.onRefresh(state)
		this.containerRef?.querySelector('div').scrollTo({top: 0})
	}

	render() {
		const {list, params, loading, total} = this.state
		// const { render, statusList, hide } = this.props
		const status =
			params.checkStatus || params.checkStatus === 0 ? [params.checkStatus] : undefined
		const fstatus = params.finalStatus || params.finalStatus === 0 ? [params.finalStatus] : undefined
		const noMore = list.length >= total

		const statuses = [{value: -1, label: '全部'}].concat(CheckStatus)
		const statusText =
			statuses.find((e) => e.value == params.checkStatus)?.label || '全部'
		const fStatuses = [{value: -1, label: '全部'}].concat(FinalStatus)
		const fStatusText =
			fStatuses.find((e) => e.value == params.finalStatus)?.label || '全部'
		return (<>
				<INavBar title={'归档'}/>
				<div className="main-page">
					<div className="main-body">
						<div className="m-tab">
							<div className="m-query-bar">
								{/* 手机号 */}
								<div className="m-row">
									<input
										className="input"
										value={params.phone}
										placeholder="请输入手机号"
										onChange={(e) => {
											const value = e.target.value
											if (isEmpty(value)) {
												params.phone = ''
											} else {
												params.phone = value
											}
											this.setState({params})
										}}
									/>
									<div
										className="btn-search"
										onClick={() => {
											const params = this.state.params
											const state = {params, pages: 0, list: [], total: 0}
											this.onRefresh(state)
										}}
									>
										搜索
									</div>
								</div>
								{/* 分类选择 */}
								<div className="m-row">
									<div className="m-filter-item">
										<span className="btn-selector-label">审批状态:</span>
										<Picker
											data={statuses}
											value={status}
											extra="全部"
											cols={1}
											onChange={(e) => {
												let statusValue: any
												if (e && e.length > 0) {
													const value: any = e[0]
													if (value === -1) {
														statusValue = undefined
													} else {
														statusValue = value
													}
												} else {
													statusValue = undefined
												}
												this.filterItemChange('cstatus', statusValue)
											}}
										>
											<span className="btn-selector-value">{statusText}</span>
										</Picker>
									</div>
									<div className="m-filter-item">
										<span className="btn-selector-label">归档状态:</span>
										<Picker
											data={fStatuses}
											value={fstatus}
											extra="全部"
											cols={1}
											onChange={(e) => {
												let statusValue: any
												if (e && e.length > 0) {
													const value: any = e[0]
													if (value === -1) {
														statusValue = undefined
													} else {
														statusValue = value
													}
												} else {
													statusValue = undefined
												}
												this.filterItemChange('fstatus', statusValue)
											}}
										>
											<span className="btn-selector-value">{fStatusText}</span>
										</Picker>
									</div>
								</div>
							</div>
							{/* list body */}
							<div className="m-body" ref={this.containerRef}>
								<EndlessList
									onTouchBottom={this.onRefresh.bind(this)}
									loading={loading}
									noMore={noMore}
								>
									<div className="m-list">
										{
											list.map((e, i) => <RenderItem data={e} key={i}/>)
										}
									</div>
								</EndlessList>
							</div>
						</div>
					</div>
				</div>
			</>
		)
	}
}


function RenderItem(props: { data: ArchiveListItem }) {
	const {data} = props

	let actionBtn: any
	if (data.checkStatus == 1) {
		actionBtn = <div onClick={() => goto(`/archiveEdit?id=${data.id}`)}>资料归档&gt;&gt;</div>
	} else if (data.checkStatus == 2 || data.checkStatus == 3) {
		actionBtn = <div onClick={() => goto(`/archiveDetail?id=${data.id}`)}>查看归档资料&gt;&gt;</div>
	} else if (data.checkStatus == 4) {
		actionBtn = <div onClick={() => goto(`/archiveEdit?id=${data.id}`)}>修改归档资料&gt;&gt;</div>
	}

	return (
		<div className="m-list-item">
			<div className="row">
				<div className="label name">{data.insuredName}</div>
				<div className="value">{data.mobile}</div>
			</div>
			<div className="row">
				<div className="label" style={{whiteSpace: 'nowrap'}}>
					放款申请通过时间
				</div>
				<div className="value">
					{data.createdAt && moment(data.createdAt).format(formatString)}
				</div>
			</div>
			<div className="row">
				<div className="label">申请车型</div>
				<div className="value">
					{data.brandName}+{data.vehicleName}
				</div>
			</div>
			<div className="row">
				<div className="label">跟单销售</div>
				<div className="value">{data.saleName}</div>
			</div>
			<div className="row">
				<div className="label">审批状态</div>
				<div className="value">{CheckStatus.find(c => c.value == data.checkStatus)?.label}</div>
				{actionBtn}
			</div>
			<div className="row">
				<div className="label">归档状态</div>
				<div className="value">{FinalStatus.find(f => f.value == data.finalStatus)?.label}</div>
			</div>
			{data.updatedAt && (
				<div className="row">
					<div className="label">更新时间</div>
					<div className="value">
						{moment(data.updatedAt).format(formatString)}
					</div>
				</div>
			)}
		</div>
	)
}
